import React from "react";

export const VendorLeadDetailContext = React.createContext(null);

export const useVendorLeadDetailContext = () => {
  const context = React.useContext(VendorLeadDetailContext);

  if (!context) throw new Error("Vendor Lead Detail Context not provided!");

  return context;
};
